interface NucleoMarkProps {
  size?: number;
  ring?: boolean;
  accent?: string;
  inkColor?: string;
  className?: string;
}

export function NucleoMark({
  size = 22,
  ring = true,
  accent = '#be3d0a',
  inkColor = '#e8e8e3',
  className,
}: NucleoMarkProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      className={className}
      style={{ display: 'block', flexShrink: 0 }}
      aria-hidden="true"
    >
      {ring && (
        <circle cx="24" cy="24" r="22" stroke={inkColor} strokeWidth="1" opacity="0.28" />
      )}
      <circle cx="24" cy="24" r="14.5" stroke={inkColor} strokeWidth="1.3" />
      <circle cx="24" cy="24" r="5.5" fill={accent} />
    </svg>
  );
}
